import React from 'react';
import { Container } from '@chakra-ui/react';
import PageTitle from '../components/PageTitle';
import JoinLeagues from '../components/JoinLeagues';

const JoinLeaguePage: React.FC = () => {
  return (
    <Container maxW="7xl" py={8}>
      <PageTitle mb={6}>Join A League</PageTitle>
      <JoinLeagues />
    </Container>
  );
};

export default JoinLeaguePage;
